import { ReactElement, useEffect, useState } from "react";
import { IAcquisitionWrapperProps } from "../../types";
import { Paper, Typography } from "@mui/material";
import { useUniqueId } from "../../../../components/charts/chartUtils";
import { IPoint } from "../../../../components/charts/types";
import { Sparklines, SparklinesLine } from "react-sparklines";
import { useAsyncFetch } from "../../../../system/useFetch";
import { IDictionary } from "../../../../types";

interface IIndicatorValues {
  title: string;
  color: string;
  unit: string | null;
  value: number | null;
  min: number | null;
  max: number | null;
  lastPoints: number[];
  formatTick: (n: number) => string;
}

interface IIndicatorProps {
  data: IIndicatorValues;
}

const Indicator = ({ data }: IIndicatorProps): ReactElement => {


  return (
    <Paper elevation={1} className={"p-2"} style={{ background: "rgba(0, 0, 0, .2)" }}>
      <div style={{ width: 300, height: 185, overflow: "hidden" }}>
        <Typography align={"center"} variant="h6" style={{ color: data.color }}>{data.title}</Typography>

        <div className="display-flex-row justify-content-center gap-1 align-items-end flex-grow-1">
          <Typography align={"center"} variant="h3">
            {data.value ? data.formatTick(data.value) : "---"}
          </Typography>
          {data.unit && <Typography align={"center"} variant={"subtitle1"}>{`[${data.unit}]`}</Typography>}
        </div>

        <div className="display-flex-row">
          {data.min &&
            <Typography align={"left"} variant="h5" className="flex-grow-1">{data.formatTick(data.min)}</Typography>}
          {data.max &&
            <Typography align={"right"} variant="h5" className="flex-grow-1">{data.formatTick(data.max)}</Typography>}
        </div>

        <Sparklines data={data.lastPoints} limit={50} width={300} height={80} margin={5}>
          <SparklinesLine color={data.color}/>
        </Sparklines>
      </div>
    </Paper>
  );
};

const IndicatorPanel = ({ parentSize, data, cell }: IAcquisitionWrapperProps): ReactElement => {
  const [indicators, setIndicators] = useState<IIndicatorValues[]>([]);
  const [getRealtimeData] = useAsyncFetch<IDictionary<any>>();

  useEffect(() => {
    console.warn("IndicatorPanel.useEffect", cell.indicatorRealtime);

    if (cell.indicatorRealtime) {
      getRealtimeData({
        module: "acquisition",
        query: "getRealtimeValues",
        payload: cell.variables.map(c => c.field)
      }).then(r => {
        console.log("IndicatorPanel.getRealtimeData", r);
      });


      // const interval = setInterval(() => {
      //
      //   getRealtimeData({
      //     module: "acquisition",
      //     query: "getRealtimeValues",
      //     payload: cell.variables.map(c => c.field)
      //   }).then(result => {
      //     console.log("IndicatorPanel.getRealtimeData", result);
      //   });
      //
      //   const result: IIndicatorValues[] = cell.variables.map(v => {
      //     const points = data.variables[v.hash] as IPoint[];
      //     const xs = points ? points.map(p => p.y as number) : [];
      //     const lastPoints = xs.length >= 50 ? xs.slice(-50) : xs;
      //
      //     const minimum = Math.min(...lastPoints);
      //     const maximum = Math.max(...lastPoints);
      //
      //     return {
      //       title: v.title,
      //       color: v.color,
      //       unit: v.unit,
      //       value: xs.at(-1) ?? null,
      //       min: minimum,
      //       max: maximum,
      //       lastPoints,
      //       formatTick: (n: number) => n.toFixed(v.decimals),
      //     };
      //   });
      //
      //   setIndicators(result);
      // }, 1000);
      //
      // return () => clearInterval(interval);
    }


    const result: IIndicatorValues[] = cell.variables.map(v => {
      const points = data.variables[v.hash] as IPoint[];
      const xs = points ? points.map(p => p.y as number) : [];
      const lastPoints = xs.length >= 50 ? xs.slice(-50) : xs;

      const minimum = Math.min(...lastPoints);
      const maximum = Math.max(...lastPoints);

      return {
        title: v.title,
        color: v.color,
        unit: v.unit,
        value: xs.at(-1) ?? null,
        min: minimum,
        max: maximum,
        lastPoints,
        formatTick: (n: number) => n.toFixed(v.decimals),
      };
    });

    setIndicators(result);
  }, [data, cell, getRealtimeData]);

  const chartID = useUniqueId("acquisition-chart");

  return (
    <div className="display-flex-row gap-3 flex-wrap align-items-start align-content-start" style={{ ...parentSize }}>
      {indicators.map((indicator, index) => {

        return <Indicator key={`${chartID}-${index}`} data={indicator}/>;
      })
      }
    </div>
  );
};

export default IndicatorPanel;
